export const text = (value: any): true => true;

export default text;
